/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_VQ_86_81 as Componente_VQ_86_81,
  rec_GQ as GQ,
  rec_HQ as HQ,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_UQ as UQ,
  rec_WQ as WQ,
} from "../../runtime/index.jsx";
export function EstadoOrden(e) {
  let t = (0, ReactCompiler.c)(7),
    { orden: n } = e,
    r,
    i;
  if (t[0] !== n.estado || t[1] !== n.solicitudes) {
    i = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      let e = (n.solicitudes ?? []).filter(GQ);
      if (e.length === 0) {
        i = null;
        break bb0;
      }
      let a = e.filter(WQ),
        o = e.filter(UQ),
        s = e.length - a.length - o.length,
        c = o.reduce(HQ, 0),
        l = a.length === 0 && o.length === e.length,
        u;
      (t[4] !== l || t[5] !== n.estado
        ? ((u = l && n.estado === `PROGRAMADA` && (
            <span
              className={`rounded-full border border-(--error) px-2 py-0.5 text-[10px] text-(--error)`}
              children={`Nadie va a subir`}
            />
          )),
          (t[4] = l),
          (t[5] = n.estado),
          (t[6] = u))
        : (u = t[6]),
        (r = (
          <div
            className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs`}
            children={[
              <span
                className={`text-(--text)`}
                children={[
                  a.length,
                  ` de `,
                  e.length,
                  ` confirmaron`,
                  s > 0 && ` · ${s} sin contestar`,
                ]}
              />,
              o.length > 0 && (
                <span
                  className={`text-(--error)`}
                  children={[
                    c,
                    ` `,
                    c === 1 ? `persona` : `personas`,
                    ` ya no van`,
                  ]}
                />
              ),
              u,
              o.map(Componente_VQ_86_81),
            ]}
          />
        )));
    }
    ((t[0] = n.estado), (t[1] = n.solicitudes), (t[2] = r), (t[3] = i));
  } else ((r = t[2]), (i = t[3]));
  return i === Symbol.for(`react.early_return_sentinel`) ? r : i;
}
